import { DeviceConnectionState, BinarySensorValueChangePayload } from '../../../../../../data-access/gql-types/graphql';
import { useChannelsStateStore } from '../../../../store/channels-state';
import { ChannelBinarySensorStateType } from '../../../../types';

export const useLavvaDeviceBinarySensorUpdate = () => {
  const setChannelState = useChannelsStateStore((s) => s.setChannelState);

  const updateLavvaBinarySensorState = ({ channelId, value }: BinarySensorValueChangePayload) => {
    setChannelState(channelId, {
      deviceConnectionState: DeviceConnectionState.Connected,
      value,
    } as ChannelBinarySensorStateType);
  };

  return {
    updateLavvaBinarySensorState,
  };
};
